import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MatriculaService {

  private apiUrl = environment.apiPortalPais;

  constructor(private http: HttpClient) { }

  buscarMatriculas(onlyActive: boolean = false): Observable<HttpResponse<any>> {
    return this.http.get(
      `${this.apiUrl}/api/matricula/buscarmatriculas`,
      { observe: 'response', params: { onlyActive: onlyActive.toString() } }
    );
  }

  buscarAnosLetivos(alunoId: number): Observable<HttpResponse<any>> {
    return this.http.get(
      `${this.apiUrl}/api/matricula/aluno/${alunoId}/anos-letivos`,
      { observe: 'response' }
    );
  }
}